import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	variables: { period: [], terms: [] },
};

export const ParameterSlice = createSlice({
	name: "parameters",
	initialState,
	reducers: {
		setParameters: (state, action) => {
			state.data = action.payload;
		},
		setVariables: (state, action) => {
			state.variables = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setParameters, setVariables } = ParameterSlice.actions;

export default ParameterSlice.reducer;
